// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8ZrwB","type":"styles_type__1WdnR","choices":"styles_choices__3Tzm7"};